<template>
	<div>
		<div class="lianxi">
			<el-row>
				<el-col :xs="24" :sm="24">
					<div style="display: flex;">
						<div><img id="header-img" src="http://dgoss.91dageng.com.cn/png/ZO93CVAiIyxInJAM3322_组 39@3x.png" /></div>
						<div class="lianxi_title">咨询动态</div>
						<div><img id="header-img" src="http://dgoss.91dageng.com.cn/png/kFL0fYbyuvLYSb8G2012_组 40@3x.png" /></div>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 盒子 -->
		<div class="border_parent">
			<el-row :gutter="10">
				<el-col :xs="24" :sm="8" v-for="(item, index) in article.slice(0, 3)" :key="index">
					<div
						class="border"
						style="padding: 40px;box-sizing: border-box;"
					>
						<div >
							<div class="border_img_parent"><img style="width: 100%;height:100%" :src="item.imageUrl" class="img_border" /></div>
							<div class="border_title">{{ item.title }}</div>
							<div class="border_content_one">{{ item.titleDescribe }}</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 盒子列表 -->
		<div class="border_parent">
			<el-row :gutter="10">
				<el-col :xs="24" :sm="12" v-for="(item, index) in articlelist" :key="index">
					<div class="border"
						style="padding: 40px;box-sizing: border-box;">
						<div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;">
							<div class="border_title">{{ item.title }}</div>
							<!-- <div class="border_img_parent" style="color: #999999;">{{ (item.createTime || '').split('T')[0] }}</div> -->
							<div class="border_img_parent" style="color: #999999;">{{ item.createTime | timeStamp }}</div>
						</div>
						<div class="border_content_one" style="text-align: left;">{{ item.titleDescribe }}</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
import { getArticleBySortName } from '@/utils/api';
export default {
	data() {
		return {
			carousel_height: '550px',
			article: [],
			articlelist:[]
		};
	},
	filters: {
		timeStamp: function(value) {
			var date = new Date(value); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
			var year = date.getFullYear();
			var month = ('0' + (date.getMonth() + 1)).slice(-2);
			var sdate = ('0' + date.getDate()).slice(-2);
			// 拼接
			var result = year + '/' + month + '/' + sdate;
			// 返回
			return result;
		}
	},
	methods: {
		async selarticle() {
			var list = await getArticleBySortName({ SortName: 'ARTICLE_WEB_B' });
			if (list.code == 200) {
				this.article = list.data;
			}
		},
		async selarticlelist() {
			var list = await getArticleBySortName({ SortName: 'ARTICLE_WEB_A' });
			if (list.code == 200) {
				this.articlelist = list.data;
			}
		}
	},
	created() {
		this.selarticle();
		this.selarticlelist()
	},
	computed: {
		//计算高度
		computeHeight() {
			let screenHeight = document.body.clientWidth;
			if (screenHeight > 415) {
				return '550px';
			} else {
				return '250px';
			}
		},
		computeArrowImg() {
			let screenHeight = document.body.clientWidth;
			if (screenHeight > 450) {
				return require('../../../static/other/arrow.png');
			} else {
				return require('../../../static/other/arrow_down.png');
			}
		}
	}
};
</script>

<style>
.border_parent {
	width: 90%;
	margin: 50px auto;
}

.slider_img {
	height: 550px;
	width: 100%;
}

.solve {
	margin-top: 30px;
	margin-bottom: 10px;
}

.border {
	border-radius: 6px;
	/* border: 1px solid #EBEEF5; */
	height: auto;
	margin: 10px;
	/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
}

.border_one {
	margin-left: 0;
}

.border_img_parent {
	margin-top: 20px;
	display: flex;
	justify-content: center;
}

.product_mobile_content {
	height: 300px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.product_mobile_img {
	width: 50%;
}

.product_mobile_title {
	font-weight: bold;
	text-align: center;
}

.product_pc_one {
	text-align: center;
	min-height: 400px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.font_size_30 {
	font-size: 1.875em;
}

.product_font_style {
	font-size: 1.125em;
}

.product_pc_img {
	width: 100%;
}

.product_pc_img_div {
	width: 50%;
	float: left;
	display: flex;
	align-items: center;
}

.product_pc {
	display: flex;
	width: 90%;
	margin: 20px auto;
	/* background: #f2f6fc; */
	align-items: center;
}

.product_spec_title {
	margin-top: 30px;
	margin-bottom: 10px;
}

.product_spec_parent {
	display: flex;
	width: 90%;
	margin: 20px auto;
	align-items: center;
	height: auto;
}

.cooperation_parent {
	display: flex;
	justify-content: center;
	width: 90%;
	margin: 20px auto;
	align-items: center;
	height: auto;
}

.border_spec {
	border-radius: 6px;
	border: 1px solid #ebeef5;
	float: left;
	width: 25%;
	height: auto;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
	font-size: 1.25em;
	font-weight: normal;
	padding: 0 20px;
	margin: 10px;
	color: #fff;
}

.border_title {
	font-family: 'PingFang SC';
	margin-top: 10px;
	font-size: 1.125em;
	font-weight: bold;
	text-align: center;
}

.border_content_one {
	width: 100%;
	margin-top: 20px;
	/* font-size: 1.125em; */
	color: #999;
	text-align: center;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.border_content_two {
	margin-top: 5px;
	font-size: 1.125em;
	margin-bottom: 25px;
	text-align: center;
	color: #0775ff;
	display: flex;
	justify-content: center;
}

.img_border {
	margin-top: 15px;
	width: 80px;
	height: 80px;
}

.border_spec_inner_one {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 35px;
	height: 70px;
}

.border_spec_content_one {
	margin-top: 15px;
	font-size: 1.125em;
	float: left;
	text-align: center;
}

.border_spec_inner_last {
	margin-top: 15px;
	font-size: 1.125em;
	float: left;
	margin-bottom: 25px;
	text-align: center;
}

.cooperation {
	margin-top: 30px;
	width: 100%;
}

.about_me {
	display: flex;
	margin-top: 30px;
	justify-content: center;
	width: 100%;
}

.product_mobile {
	width: 90%;
	align-items: center;
	margin: 20px auto;
	/* background: #f2f6fc; */
}

.product_mobile_img_div {
	width: 50%;
	height: auto;
}

.product_mobile_content_one {
	margin-top: 20px;
	text-align: center;
}

.product_mobile_content_two {
	margin-top: 10px;
	text-align: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
	.slider_img {
		height: 250px;
		width: 100%;
	}

	.border_parent {
		display: flex;
		width: 90%;
		margin: auto;
		height: auto;
		flex-direction: column;
	}

	.border {
		border-radius: 6px;
		/* border: 1px solid #EBEEF5; */
		float: left;
		width: 100%;
		height: auto;
		margin: 10px 0 auto;
		/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
		/*background: aquamarine;*/
	}

	.border_img_parent {
		margin-top: 0;
	}

	.product_mobile {
		width: 90%;
		align-items: center;
		margin: 20px auto;
		height: auto;
		/* background: #f2f6fc; */
	}

	.product_mobile_content {
		width: 100%;
		margin-top: 15px;
	}

	.product_mobile_content_one {
		margin-top: 5px;
	}

	.product_mobile_content_two {
		margin-top: 5px;
	}

	.product_mobile_img_div {
		display: flex;
		width: 100%;
		height: auto;
		justify-content: center;
		margin-top: 10px;
		margin-bottom: 15px;
	}

	.product_mobile_img {
		float: left;
	}

	.product_mobile_title {
		font-weight: bold;
	}

	.product_pc_one {
		width: 100%;
		margin-top: 15px;
	}

	.font_size_30 {
		font-size: 1.25em;
	}

	.product_font_style {
		font-size: 1em;
	}

	.product_pc_img {
		height: 280px;
		width: 320px;
	}

	.product_pc_img_div {
		width: 100%;
		float: left;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 15px;
	}

	.product_pc {
		display: flex;
		width: 90%;
		height: auto;
		margin: 20px auto;
		/* background: #f2f6fc; */
		flex-direction: column;
	}

	.head-label {
		display: flex;
		margin-top: 10px;
	}

	.product_spec_parent {
		display: flex;
		width: 90%;
		align-items: center;
		justify-content: center;
		margin: 20px auto;
		height: auto;
		flex-direction: column;
	}

	.border_spec {
		float: left;
		height: auto;
		margin: 8px;
		width: 100%;
		border-radius: 6px;
		border: 1px solid #ebeef5;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.border_title {
		font-family: 'PingFang SC';
		margin-top: 5px;
		font-size: 1.125em;
		font-weight: bold;
	}

	.border_content_one {
		margin-top: 5px;
		color: #999999;
		/* font-size: 1.125em; */
	}

	.border_content_two {
		margin-top: 5px;
		font-size: 1.125em;
		margin-bottom: 8px;
		color: #0775ff;
		display: flex;
		justify-content: center;
	}

	.img_border {
		margin-top: 8px;
		width: 80px;
		height: 80px;
	}

	.border_spec_inner_one {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 8px;
		/*background-color: aqua;*/
		height: 70px;
	}

	.border_spec_content_one {
		margin-top: 5px;
		font-size: 1.125em;
		float: left;
	}

	.border_spec_inner_last {
		/*background-color: bisque;*/
		margin-top: 5px;
		font-size: 1.125em;
		float: left;
		margin-bottom: 8px;
	}

	.about_me {
		display: flex;
		margin-top: 10px;
		width: 100%;
	}
}

.border_spec_img {
	width: 75px;
	height: 55px;
	align-self: center;
}

.font_size_24 {
	font-size: 1.5em;
}
</style>
